import classNames from 'classnames'

import ProductReview from '@src/quince-site-common/src/domains/ProductReview'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { getReviewImageAltText } from '@src/quince-site-pdp/src/atoms/reviewPopUp/utils'

import Swiper from '../../custom-swiper'
import Image from '../../image'

// style
import styles from './productReviewGallerySlider.module.scss'
import stylesV2 from './productReviewGallerySliderV2.module.scss'

export interface ProductReviewGallerySliderProps {
  heading: string
  productReviews: ProductReview[]
  onReviewImageClick: (reviewId: number, imageIndex: number) => void
  productTitle?: string
  newPdpv2?: boolean
  isHighlightSection?: boolean
}

export const ProductReviewGallerySlider = (props: ProductReviewGallerySliderProps) => {
  const deviceInfo = useDeviceInfo()
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP
  const finalStyles = props.newPdpv2 ? stylesV2 : styles
  return (
    <div
      className={classNames(finalStyles.gallaryWrap, {
        [finalStyles.gallaryWrap__extraPadding ?? '']: !props.isHighlightSection,
      })}
    >
      <div
        className={classNames(finalStyles.galleryInner, {
          [finalStyles.galleryInner__highlightSection ?? '']: props.isHighlightSection,
        })}
      >
        {props.heading && (
          <h2 data-testid="review-section-gallery-heading" className={finalStyles.heading}>
            {props.heading}
          </h2>
        )}
        <Swiper
          id={'product-review-gallery-slider'}
          showNavigator={isDesktop}
          numberOfVisibleSlides={8}
          className={finalStyles.gallerySliderWrap}
          virtualOptions={{ enabled: true }}
          prevIconClass={finalStyles.prevArrowIcon}
          nextIconClass={finalStyles.nextArrowIcon}
        >
          {props.productReviews.map((review: ProductReview) => {
            return review.imagesFileUrls?.map((fileUrl: string, imageIndex) => {
              return (
                <div
                  key={fileUrl}
                  onClick={() => {
                    props.onReviewImageClick(review.id, imageIndex)
                  }}
                  className={finalStyles.slideItem}
                >
                  <Image
                    alt={getReviewImageAltText({ reviewTitle: review.title, productTitle: props.productTitle })}
                    title={review.title}
                    url={fileUrl}
                    key={fileUrl}
                    className={classNames(finalStyles.slideImage, {
                      [finalStyles.slideImage_highlight ?? '']: props.isHighlightSection,
                    })}
                    fillWithBlackBackground={false}
                    // @i18n-ignore
                    loading={'lazy'}
                  />
                </div>
              )
            })
          })}
        </Swiper>
      </div>
    </div>
  )
}

export default ProductReviewGallerySlider
